import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';

import {
  StyleSheet,
} from 'react-native';

const {
  fontBold,
  fontRegular,
  fontSizeH4,
  fontSizeH5,
  textColorPrimary,
} = SkillzStyle.fullStyles;

const labelFontSize = Sizes.select({phone: fontSizeH5, tablet: fontSizeH4});

export const PLACEHOLDER_OPACITY = 0.7;

export default StyleSheet.create({
  labelContainer: {
    marginTop: 2,
  },

  title: {
    ...labelFontSize,
    ...textColorPrimary,
    ...fontBold,
    textAlign: 'center',
    textAlignVertical: 'center',
  },

  subtitle: {
    ...labelFontSize,
    ...textColorPrimary,
    ...fontRegular,
    textAlign: 'center',
    textAlignVertical: 'center',
  },
});
